import { HttpParams } from '@angular/common/http';

import { Filter } from '../../../models';
import { KPI_CROSS_SELL_UP_SELL } from '../../kpis';

/** Representa o Filter de pesquisa da entidade Classificacao */
export class ClassificacaoFilter implements Filter {
    isFilterDirty = false;

    filterPsq: string;
    situacao: number;
    idsTiposClassificacoes: number[] = [];
    idTipoClassificacao: number;
    cadastrosTipoClassificacao: number[] = [];
    niveisTipoClassificacao: number[] = [];
    idClassificacaoPai: number;
    crossSells: number[] = [];

    /** Cria os parâmetros do filtro */
    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Filtro de Pesquisa
        if (this.filterPsq) {
            params = params.append('filterPsq', this.filterPsq);
        }

        // Situação
        if (this.situacao) {
            params = params.append('situacao', this.situacao.toString());
        }

        // Tipos de classificaçãos
        this.idsTiposClassificacoes?.forEach(idTipoClassificacao => params = params.append('idTipoClassificacao', idTipoClassificacao.toString()));
        if (this.idTipoClassificacao) {
            params = params.append('idTipoClassificacao', this.idTipoClassificacao.toString());
        }

        // Cadastros dos Tipos de Classificações
        this.cadastrosTipoClassificacao?.forEach(cadastroTipoClassificacao => params = params.append('cadastroTipoClassificacao', cadastroTipoClassificacao.toString()));

        // Niveis dos Tipos de Classificações
        this.niveisTipoClassificacao?.forEach(nivelTipoClassificacao => params = params.append('nivelTipoClassificacao', nivelTipoClassificacao.toString()));

        // Classificação Pai
        if (this.idClassificacaoPai) {
            params = params.append('idClassificacaoPai', this.idClassificacaoPai.toString());
        }

        // Cross Sells
        this.crossSells?.forEach(crossSell => params = params.append('crossSell', crossSell.toString()));

        return params;
    }

    clear() {
        this.isFilterDirty = false;

        this.filterPsq = null;
        this.situacao = null;
        this.idsTiposClassificacoes = [];
        this.idTipoClassificacao = null;
        this.cadastrosTipoClassificacao = [];
        this.niveisTipoClassificacao = [];
        this.idClassificacaoPai = null;
        this.crossSells = [];
    }
}

